/* GTJ watch PDP availability controller.
   Uses only the main visible product form; hidden quick-shop/add-to-cart controls elsewhere on the page are ignored. */
(function () {
  'use strict';

  var WATCH_PAGE_CLASSES = [
    'breitling-product-page',
    'corum-product-page',
    'grand-seiko-product-page',
    'gucci-product-page',
    'hamilton-product-page',
    'longines-product-page',
    'mido-product-page',
    'norqain-product-page',
    'omega-product-page',
    'rado-product-page',
    'tagheuer-product-page',
    'tissot-product-page',
    'tudor-product-page'
  ];

  function isWatchPage() {
    return WATCH_PAGE_CLASSES.some(function (className) {
      return document.body.classList.contains(className);
    });
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getMainAddToCartButton() {
    var productSection = document.querySelector('.product-section');
    if (!productSection) return null;

    var buttons = productSection.querySelectorAll('[data-add-to-cart], .add-to-cart');
    for (var i = 0; i < buttons.length; i += 1) {
      if (isVisible(buttons[i])) return buttons[i];
    }
    return null;
  }

  function grandSeikoInquiryIsAvailable() {
    if (!document.body.classList.contains('grand-seiko-product-page')) return false;
    var inquiryDot = document.querySelector('.grand-seiko-product__availability-dot--inquiry');
    if (!inquiryDot) return false;

    var variantJson = document.querySelector('[data-current-variant-json]');
    if (variantJson) {
      try {
        var variant = JSON.parse(variantJson.textContent || variantJson.innerHTML || '{}');
        if (typeof variant.available === 'boolean') return variant.available;
      } catch (error) {
        /* Fall through to the rendered status copy. */
      }
    }

    var status = inquiryDot.closest('[role="status"]');
    return !!(status && /^\s*Available\b/i.test(status.textContent || ''));
  }

  function updateAvailabilityState() {
    if (!isWatchPage()) return;

    var button = getMainAddToCartButton();
    var available = !!(button && !button.disabled && button.getAttribute('aria-disabled') !== 'true');
    var inquiryAvailable = !button && grandSeikoInquiryIsAvailable();

    document.body.classList.toggle('gtj-watch-variant-available', available);
    document.body.classList.toggle('gtj-watch-variant-unavailable', !available && !inquiryAvailable);
    document.body.classList.toggle('gtj-watch-inquiry-available', inquiryAvailable);
  }

  var queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      updateAvailabilityState();
    });
  }

  function init() {
    if (!isWatchPage()) return;

    updateAvailabilityState();

    var productSection = document.querySelector('.product-section');
    if (productSection && window.MutationObserver) {
      new MutationObserver(queueUpdate).observe(productSection, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'class', 'style']
      });
    }

    document.addEventListener('change', queueUpdate, true);
    document.addEventListener('variant:change', queueUpdate);
    window.addEventListener('pageshow', queueUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
